import * as types from './types';

export function onTokenChanged(token) {
  return {
    type: types.TOKEN_CHANGED,
    payload: { token: token, isInitialized: true }
  };
}

export function onPermissionChanged(hasPermission, onMessage) {
  return {
    type: types.PERMISSION_CHANGED,
    payload: { hasPermission: hasPermission, isInitialized: true }
  };
}

export function onMessage(message) {
  return {
    type: types.ON_MESSAGE,
    payload: { message: message }
  };
}
export function clearMessage() {
  return {
    type: types.ON_CLEAR_MESSAGE
  };
}

export function onMessagingError(error) {
  return {
    type: types.MESSAGING_ERROR,
    payload: { error: error }
  };
}

export function initMessaging(firebaseApp, handleTokenChange, onMessageReceieved) {
  return function (dispatch) {
    var messaging = firebaseApp.messaging();

    try {
      messaging.requestPermission().then(function () {
        return messaging.getToken();
      }).then(function (token) {
        if (handleTokenChange !== undefined && handleTokenChange instanceof Function) {
          handleTokenChange(token);
        }

        dispatch(onTokenChanged(token));
      }).catch(function (error) {
        dispatch(onPermissionChanged(false));
      });
    } catch (e) {
      dispatch(onPermissionChanged(false));
    }

    messaging.onMessage(function (payload) {
      if (onMessageReceieved !== undefined && onMessageReceieved instanceof Function) {
        onMessageReceieved(payload);
      }

      dispatch(onMessage(payload));
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/firekit/es/store/messaging/actions.js
// module id = 687
// module chunks = 49